module.exports = __webpack_public_path__ + "img/logo_Uruguai_Comite_EEI.fe88288f.png";